module.exports = __webpack_public_path__ + "static/media/BlackDotted.ab58ed07.svg";